    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="定制菜单id:">
                            <el-select v-model="table.where.custom_id" filterable placeholder="请选择">
                                <el-option v-for="item in custom_menu_list" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="名称:">
                            <el-input v-model="table.where.name" placeholder="请输入名称" clearable />
                        </el-form-item>

                        <el-form-item label="重量(斤):">
                            <el-input-number v-model="table.where.weight" placeholder="请输入重量(斤)" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="单位:">
                            <el-input v-model="table.where.unit" placeholder="请输入单位" clearable />
                        </el-form-item>

                        <el-form-item label="每箱数量:">
                            <el-input-number v-model="table.where.num" placeholder="请输入每箱数量" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="状态:">
                            <el-select v-model="table.where.status" filterable placeholder="请选择">
                                <el-option label="显示" value="1"></el-option>
                                <el-option label="不显示" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>


                        <el-form-item label="排序:">
                            <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:customml:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:customml:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:customml:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="custom_id" label="场景选择关联" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.custom_id_info" :key="index">{{item.name}}</el-tag>
                            </template>
                        </el-table-column>


                        <el-table-column prop="name" label="名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="weight" label="重量(斤)" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="unit" label="单位" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="num" label="每箱数量" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                    :inactive-value="0" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="image" label="缩略图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.image"
                                    :preview-src-list="[row.image]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="custom_id_info.name" label="名称" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.custom_id_info" :key="index">
                                    {{ item.name }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:customml:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此场景容量分类吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:customml:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改场景容量分类':'添加场景容量分类'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                    <el-form-item label="场景选择关联:" prop="custom_id">
                        <el-select v-model="editForm.custom_id" filterable placeholder="请选择">
                            <el-option v-for="item in custom_menu_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="名称:" prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入名称" clearable />
                    </el-form-item>

                    <el-form-item label="重量(斤):" prop="weight">
                        <el-input-number v-model="editForm.weight" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入重量(斤)" clearable />
                    </el-form-item>

                    <el-form-item label="单位:" prop="unit">
                        <el-input v-model="editForm.unit" placeholder="请输入单位" clearable />
                    </el-form-item>

                    <el-form-item label="每箱数量:" prop="num">
                        <el-input-number v-model="editForm.num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入每箱数量" clearable />
                    </el-form-item>


                    <el-form-item label="状态:" prop="status">
                        <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                            :inactive-value="0" />

                    </el-form-item>



                    <el-form-item label="缩略图:" prop="image">
                        <ele-uploadimage :limit="1" v-model="editForm.image"></ele-uploadimage>

                    </el-form-item>

                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'

        export default {
            name: "SysCustomMl",
            components: {
                EleUploadimage,
            },
            data() {
                return {
                    table: {
                        url: '/custom/CustomMl/index',
                        where: {
                            "image": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "image": []
                    }, // 表单数据
                    editFormTemp: {
                        "image": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    custom_menu_list: [],
                    editRules: { // 表单验证规则

                        custom_id: [{
                            required: true,
                            message: '请选择定制菜单id',
                            trigger: 'blur'
                        }],


                        name: [{
                            required: true,
                            message: '请输入名称',
                            trigger: 'blur'
                        }],


                        weight: [{
                            required: true,
                            message: '请输入重量(斤)',
                            trigger: 'blur'
                        }],


                        unit: [{
                            required: true,
                            message: '请输入单位',
                            trigger: 'blur'
                        }],


                        num: [{
                            required: true,
                            message: '请输入每箱数量',
                            trigger: 'blur'
                        }],



                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        image: [{
                            required: true,
                            message: '请上传缩略图',
                            trigger: 'blur'
                        }],




                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.CustomMenuAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/custom/CustomMl/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomMl/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的场景容量分类吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomMl/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/custom/CustomMl/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/custom/CustomMl/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                CustomMenuAllList() {
                    this.$http.post('/custom/CustomMenu/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.custom_menu_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/custom/CustomMl/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>